import { SelfSignupEffects } from './effects/self-signup.effects';

export const effects = [
	SelfSignupEffects
];